import { Member } from '../interfaces/member.interface';
import { MemberType } from '../enums/member-type.enum';
import { PortalDisplayPage } from '../enums';
import { DisplayPriceConfig } from '../interfaces/display-price-config.interface';
import { MemberDisplayConfigInfo } from '../interfaces/member-display-config-info.interface';
import { MemberLevel } from '../enums/member-level.enum';
import { environment } from 'src/environments/environment';

export class MemberDisplayPriceConfigService {
    constructor() { }

    /**
     *
     */
    private getApplicablePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, enableWHLSAL00ForAsstSupervisor: boolean): boolean {
        let displayApplicablePrice = true;
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && !enableWHLSAL00ForAsstSupervisor))
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.CartSummary ||
                displayPage === PortalDisplayPage.OrderSummary) {
                if (taxInclusiveShippingCountry && vatRegistered && !taxCalculated) {
                    displayApplicablePrice = true;
                } else if (taxInclusiveShippingCountry && vatRegistered && taxCalculated) {
                    displayApplicablePrice = false;
                } else if (taxInclusiveShippingCountry && !vatRegistered
                    && !userInfo.transactionalWholesaleQualified && !userInfo.transactionalOptin) {
                    displayApplicablePrice = true;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayApplicablePrice = false;
                } else if (!taxInclusiveShippingCountry) {
                    displayApplicablePrice = false;
                }
            } else if (displayPage === PortalDisplayPage.ProductList ||
                displayPage === PortalDisplayPage.ProductDetail ||
                displayPage === PortalDisplayPage.ShoppingCart) {
                if (vatRegistered) {
                    displayApplicablePrice = true;
                } else if (!vatRegistered && !userInfo.transactionalWholesaleQualified && !userInfo.transactionalOptin) {
                    displayApplicablePrice = true;
                } else if (!vatRegistered) {
                    displayApplicablePrice = false;
                } else {
                    displayApplicablePrice = true;
                }
            } else {
                displayApplicablePrice = true;
            }
        } else {
            displayApplicablePrice = true;
        }
        return displayApplicablePrice;
    }

    /**
    *
    */
    private getCatalogPriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, enableWHLSAL00ForAsstSupervisor: boolean): boolean {
        let displayCatalogPrice = false;
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && !enableWHLSAL00ForAsstSupervisor))
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.CartSummary ||
                displayPage === PortalDisplayPage.OrderSummary) {
                if (taxInclusiveShippingCountry && vatRegistered && !taxCalculated) {
                    displayCatalogPrice = false;
                } else if (taxInclusiveShippingCountry && vatRegistered && taxCalculated) {
                    displayCatalogPrice = true;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayCatalogPrice = true;
                }
            } else {
                displayCatalogPrice = false;
            }
        } else {
            displayCatalogPrice = false;
        }
        return displayCatalogPrice;
    }

    /**
     *
     */
    private getComputedTaxInclusivePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, enableWHLSAL00ForAsstSupervisor: boolean): boolean {
        let displayComputedTaxInclusivePrice = false;
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && !enableWHLSAL00ForAsstSupervisor))
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.ProductList ||
                displayPage === PortalDisplayPage.ProductDetail ||
                displayPage === PortalDisplayPage.ShoppingCart ||
                displayPage === PortalDisplayPage.CartSummary ||
                displayPage === PortalDisplayPage.OrderSummary) {
                if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayComputedTaxInclusivePrice = true;
                } else if (!taxInclusiveShippingCountry) {
                    displayComputedTaxInclusivePrice = false;
                } else if (vatRegistered) {
                    displayComputedTaxInclusivePrice = false;
                }
            } else {
                displayComputedTaxInclusivePrice = false;
            }
        } else {
            displayComputedTaxInclusivePrice = false;
        }
        return displayComputedTaxInclusivePrice;
    }

    /**
    *
    */
    private getRetailPriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, enableWHLSAL00ForAsstSupervisor: boolean): boolean {
        let displayRetailPrice = true;
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.ProductList ||
                displayPage === PortalDisplayPage.ProductDetail ||
                displayPage === PortalDisplayPage.ShoppingCart ||
                displayPage === PortalDisplayPage.CartSummary ||
                displayPage === PortalDisplayPage.OrderSummary) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayRetailPrice = false;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayRetailPrice = false;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayRetailPrice = true;
                } else if (!taxInclusiveShippingCountry) {
                    displayRetailPrice = true;
                }
            } else {
                displayRetailPrice = true;
            }
        } else {
            displayRetailPrice = true;
        }
        return displayRetailPrice;
    }

    /**
    *
    */
    private getBaseRetailPriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, enableWHLSAL00ForAsstSupervisor: boolean): boolean {
        let displayBaseRetailPrice = false;
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.ProductList ||
                displayPage === PortalDisplayPage.ProductDetail ||
                displayPage === PortalDisplayPage.ShoppingCart ||
                displayPage === PortalDisplayPage.CartSummary ||
                displayPage === PortalDisplayPage.OrderSummary) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseRetailPrice = true;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseRetailPrice = true;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayBaseRetailPrice = false;
                } else if (!taxInclusiveShippingCountry) {
                    displayBaseRetailPrice = false;
                }
            } else {
                displayBaseRetailPrice = false;
            }
        } else {
            displayBaseRetailPrice = false;
        }
        return displayBaseRetailPrice;
    }


    /**
    *
    */
    private getWholesalePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, enableWHLSAL00ForAsstSupervisor: boolean): boolean {
        let displayWholesalePrice = true;
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.ProductList ||
                displayPage === PortalDisplayPage.ProductDetail ||
                displayPage === PortalDisplayPage.ShoppingCart ||
                displayPage === PortalDisplayPage.CartSummary ||
                displayPage === PortalDisplayPage.OrderSummary) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayWholesalePrice = false;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayWholesalePrice = false;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayWholesalePrice = true;
                } else if (!taxInclusiveShippingCountry) {
                    displayWholesalePrice = true;
                }
            } else {
                displayWholesalePrice = true;
            }
        } else {
            displayWholesalePrice = true;
        }
        return displayWholesalePrice;
    }

    /**
    *
    */
    private getBaseWholesalePriceConfig(displayPage: number, taxInclusiveStore: boolean,
        userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean, enableWHLSAL00ForAsstSupervisor: boolean): boolean {
        let displayBaseWholesalePrice = false;
        const vatRegistered = userInfo ? userInfo.vatRegistered : false;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && userInfo.transactionalWholesaleQualified && userInfo.transactionalOptin
            && taxInclusiveStore) {
            if (displayPage === PortalDisplayPage.ProductList ||
                displayPage === PortalDisplayPage.ProductDetail ||
                displayPage === PortalDisplayPage.ShoppingCart ||
                displayPage === PortalDisplayPage.CartSummary ||
                displayPage === PortalDisplayPage.OrderSummary) {
                if (taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseWholesalePrice = true;
                } else if (!taxInclusiveShippingCountry && vatRegistered) {
                    displayBaseWholesalePrice = true;
                } else if (taxInclusiveShippingCountry && !vatRegistered) {
                    displayBaseWholesalePrice = false;
                } else if (!taxInclusiveShippingCountry) {
                    displayBaseWholesalePrice = false;
                }
            } else {
                displayBaseWholesalePrice = false;
            }
        } else {
            displayBaseWholesalePrice = false;
        }
        return displayBaseWholesalePrice;
    }

    /**
    *
    */
    getDisplayPriceConfig(memberDisplayConfigInfo: MemberDisplayConfigInfo): DisplayPriceConfig {
        const displayPriceConfig: DisplayPriceConfig = {
            displayApplicablePrice: this.getApplicablePriceConfig(memberDisplayConfigInfo.displayPage, memberDisplayConfigInfo.taxInclusiveStore,
                memberDisplayConfigInfo.userInfo, memberDisplayConfigInfo.taxCalculated, memberDisplayConfigInfo.taxInclusiveShippingCountry,
                memberDisplayConfigInfo.enableWHLSAL00ForAsstSupervisor),
            displayCatalogPrice: this.getCatalogPriceConfig(memberDisplayConfigInfo.displayPage, memberDisplayConfigInfo.taxInclusiveStore,
                memberDisplayConfigInfo.userInfo, memberDisplayConfigInfo.taxCalculated, memberDisplayConfigInfo.taxInclusiveShippingCountry,
                memberDisplayConfigInfo.enableWHLSAL00ForAsstSupervisor),
            displayRetailPrice: this.getRetailPriceConfig(memberDisplayConfigInfo.displayPage, memberDisplayConfigInfo.taxInclusiveStore,
                memberDisplayConfigInfo.userInfo, memberDisplayConfigInfo.taxCalculated, memberDisplayConfigInfo.taxInclusiveShippingCountry,
                memberDisplayConfigInfo.enableWHLSAL00ForAsstSupervisor),
            displayBaseRetailPrice: this.getBaseRetailPriceConfig(memberDisplayConfigInfo.displayPage, memberDisplayConfigInfo.taxInclusiveStore,
                memberDisplayConfigInfo.userInfo, memberDisplayConfigInfo.taxCalculated, memberDisplayConfigInfo.taxInclusiveShippingCountry,
                memberDisplayConfigInfo.enableWHLSAL00ForAsstSupervisor),
            displayWholesalePrice: this.getWholesalePriceConfig(memberDisplayConfigInfo.displayPage, memberDisplayConfigInfo.taxInclusiveStore,
                memberDisplayConfigInfo.userInfo, memberDisplayConfigInfo.taxCalculated, memberDisplayConfigInfo.taxInclusiveShippingCountry,
                memberDisplayConfigInfo.enableWHLSAL00ForAsstSupervisor),
            displayBaseWholesalePrice: this.getBaseWholesalePriceConfig(memberDisplayConfigInfo.displayPage, memberDisplayConfigInfo.taxInclusiveStore,
                memberDisplayConfigInfo.userInfo, memberDisplayConfigInfo.taxCalculated, memberDisplayConfigInfo.taxInclusiveShippingCountry,
                memberDisplayConfigInfo.enableWHLSAL00ForAsstSupervisor),
            displayComputedTaxInclusivePrice: this.getComputedTaxInclusivePriceConfig(memberDisplayConfigInfo.displayPage, memberDisplayConfigInfo.taxInclusiveStore,
                memberDisplayConfigInfo.userInfo, memberDisplayConfigInfo.taxCalculated, memberDisplayConfigInfo.taxInclusiveShippingCountry,
                memberDisplayConfigInfo.enableWHLSAL00ForAsstSupervisor),
            displayStrikeoutPrice: this.getStrikeoutPriceConfig(memberDisplayConfigInfo)

        };
        return displayPriceConfig;
    }

    /**
    * getStrikeoutPriceConfig()
    */
    getStrikeoutPriceConfig(memberDisplayConfigInfo: MemberDisplayConfigInfo): boolean {
        let displayStrikeoutPrice;
        const memberTitleID = this.getMemberTitleId(memberDisplayConfigInfo.userInfo);
        const shareFBOID = memberDisplayConfigInfo.shareFBOID;
        const memberSalePromotionModel = memberDisplayConfigInfo.memberSalePromotionModel;
        if ((memberTitleID === MemberLevel.RETAIL && shareFBOID && memberSalePromotionModel)
            || memberTitleID !== MemberLevel.RETAIL) {
            displayStrikeoutPrice = true;
        } else {
            displayStrikeoutPrice = false;
        }
        return displayStrikeoutPrice;
    }

    /**
        * get active member Title Id
        * @returns number
        */
    getMemberTitleId(userInfo: Member): number {
        if (userInfo && userInfo.memberTitleId) {
            return userInfo.memberTitleId;
        } else {
            return MemberLevel.RETAIL;
        }
    }

}
